import { TOwnInfo } from '~/store/user/user.type';
import { SearchCategory } from '~/types/enum';

export enum resourceCategory {
  CRAM_SCHOOL = '補教',
  SCHOOL = '學校',
}

export enum internetCategory {
  PUBLIC = '公開',
  SCHOOL = '學校',
}

export enum resourceVersion {
  H = '翰林',
  K = '康軒',
  N = '南一',
  HE = '何嘉仁',
}

export enum resourceEduCode {
  E = '國小',
  J = '國中',
  H = '高中',
}

export type ResourceSearchKeyType = {
  [key: string]: string;
};

export type TOneBoxV3GetResourcesPayload = {
  search?: {
    categories?: SearchCategory[];
    versions?: resourceVersion;
    years?: string;
    eduCodes?: resourceEduCode;
    subjects?: string;
    grades?: string;
    resources1?: string;
    resources2?: string;
    resources3?: string;
    fileName?: string;
  };
  fuzzySearch?: string;
  isLaunch?: boolean;
  dateFrom?: string;
  dateTo?: string;
  pagination: {
    page: number | null;
    pageSize: number | null;
    sort: string | null;
  };
};

export type TResource = {
  _id: string;
  categories: resourceCategory[];
  versions: resourceVersion[];
  years: string[]; // ['112上']
  eduCodes: resourceEduCode[];
  subjects: string[];
  grades: string[];
  originalFileId: string;
  resources1: string[];
  resources2: string[];
  resources3: string[];
  chapterKeyword: string[];
  knowledge: [];
  fileName: string;
  displayName: string;
  isLaunch: boolean;
  coverImg: string;
  bookId: string;
  file: {
    _id: string;
    category: resourceCategory;
    version: resourceVersion;
    year: string;
    eduCode: resourceEduCode;
    subject: string;
    grade: string;
    resource1: string;
    resource2: string;
    resource3?: string;
    fileName: string;
    originalFileId: string;
    fileUploadTime: string;
    url: string;
    fileSize: number;
    dataSource: string;
    bookId: string;
  };
};

export type TOneBoxV3GetResources = {
  currentPage: number;
  data: TResource[];
  totalAmount: number;
  totalPages: number;
};

export type TOneBoxV3UpdateLaunchStatusPayload = {
  ids: string[];
  isLaunch: boolean;
};

export type TOneBoxV3UpdateByFilePayload = FormData;

export type TOneBoxV3UpdateByFile = {
  errorCodes?: string[];
  errorId?: string;
  errorResourceColumns?: string[];
};

export type TOneBoxV3UpdateByOriginalFileIdPayload = {
  originalFileId: string;
  categories: string[];
  versions: string[];
  years: string[];
  eduCodes: string[];
  subjects: string[];
  grades: string[];
  resources1: string[];
  resources2: string[];
  resources3: string[];
  knowledge: string[];
  isLaunch: boolean;
};

export type TOneBoxV3UpdateByOriginalFileId = {
  errorId: string;
  errorResourceColumns: string[];
};

export type TOneBoxV3DropDownList = {
  uniqResourceProps: TUniqResourceProps;
};

export type TUniqResourceProps = {
  versions?: string[];
  years?: string[];
  eduCodes?: string[];
  subjects?: string[];
  grades?: string[];
  resources1?: string[];
  resources2?: string[];
  resources3?: string[];
  search?: TOneBoxV3DropDownListSearch;
  fuzzySearchFields?: string[];
};

export type TOneBoxV3DropDownListPayload = {
  isLaunch?: boolean;
  categories: SearchCategory[];
  resourceProps: string[];
  search?: TOneBoxV3DropDownListSearch;
};

export type TOneBoxV3DropDownListSearch = {
  years?: string;
  eduCodes?: string | null;
  subjects?: string | null;
  grades?: string;
  resources1?: string;
};

export type TOneBoxV3GetRecordsPayload = {
  dateFrom?: string;
  dateTo?: string;
  pagination: {
    page: number | null;
    pageSize: number | null;
    sort: number | null;
  };
};

export type TRecord = {
  disabled: boolean;
  createdAt: string;
  updatedAt: string;
  _id: string;
  originalName: string;
  gcsFileName: string;
  recordTime: string;
  url: string;
};

export type TOneBoxV3GetRecords = {
  totalAmount: number;
  totalPages: number;
  currentPage: number;
  data: TRecord[];
};

export type TInternetResource = {
  _id: string;
  category: internetCategory;
  years: string[];
  eduCodes: resourceEduCode[];
  subjects: string[];
  grades: string[];
  resources1: string[];
  resources2: string[];
  urlName: string;
  url: string;
  isLaunch: boolean;
};

export type TOneBoxV3GetInternetResources = {
  totalAmount: number;
  totalPages: number;
  currentPage: number;
  data: TInternetResource[];
};

export type TOneBoxV3GetInternetResourcesPayload = {
  search?: {
    category?: internetCategory[] | 'all' | undefined;
    years?: string;
    eduCodes?: resourceEduCode;
    subjects?: string;
    grades?: string;
    resources1?: string;
    resources2?: string;
    urlName?: string;
  };
  fuzzySearch?: string;
  isLaunch: boolean;
  pagination: {
    page: number | null;
    pageSize: number | null;
    sort: string | null;
  };
};

export type TOneBoxV3InternetDropDownList = {
  uniqInternetResourceProps: TUniqInternetResourceProps;
};

export type TUniqInternetResourceProps = {
  years?: string[];
  eduCodes?: string[];
  subjects?: string[];
  grades?: string[];
  resources1?: string[];
  resources2?: string[];
  search?: TOneBoxV3DropDownListSearch;
};

export type TOneBoxV3InternetDropDownListPayload = {
  isLaunch?: boolean;
  categories: string[];
  internetResourceProps: string[];
  search?: TOneBoxV3DropDownListSearch;
};

export type TOneBoxV3UpdateInternetByFile = {
  errorCodes?: string[];
  errorId?: string;
  errorResourceColumns?: string[];
};

export type TOneBoxV3UpdateInternetByFilePayload = FormData;

export type TOneBoxV3UpdateInternetByIdPayload = {
  _id: string;
  category: string;
  years: string[];
  eduCodes: string[];
  subjects: string[];
  grades: string[];
  resources1: string[];
  resources2: string[];
  urlName: string;
  url: string;
  isLaunch: boolean;
};

export type TOneBoxV3GetOwnInfo = TOwnInfo;

export type TOneBoxV3GetKnowledge = {
  bookId: string;
  chapters: TChapters[];
};

export type TChapters = {
  code: string;
  knowledgeIndexes: string[];
};

export type TOneBoxV3GetKnowledgePayload = {
  version: string;
  year: string;
  eduCode: string;
  subject: string;
  grade: string;
};

export type TOneBoxV3GetResourcesRecommend = {
  totalAmount: number;
  totalPages: number;
  currentPage: number;
  groupValues: string[];
  data: TResource[];
};

export type TOneBoxV3GetResourcesRecommendPayload = {
  year: string;
  weekNumber: number;
  eduCode: string;
  subject: string;
  grade: string;
  resources1: string[];
  pagination: {
    page: number | null;
    pageSize: number | null;
    sort: string | null;
    paginateBy: string | null;
  };
};

export type TResourceConfigs = {
  _id?: string;
  eduCode: string;
  subject: string;
  grade: string;
  resources1: string[];
};

export type TDisplayWeekInfos = {
  currentYear: string;
  currentSemester: string;
  currentWeek: number;
  weekStart: string;
  weekEnd: string;
  lastWeek: number;
  userDisplayWeek: number;
  userDisplayWeekStart: string;
  userDisplayWeekEnd: string;
};

export type TPopUp = {
  isFeatureEnabled: boolean;
  reminderPeriod: string;
  isDisplayPaused: boolean;
  pauseStartDate?: string;
  pauseEndDate?: string;
};

export type TWeekAdjust = {
  userYear: string;
  userSemester: string;
  userWeek: number;
};

export type TOneBoxV3GetRecommendSettings = {
  disabled: boolean;
  createdAt: string;
  updatedAt: string;
  _id: string;
  userId: string;
  resourceConfigs: TResourceConfigs[];
  popUp: TPopUp;
  weekAdjust: TWeekAdjust;
  displayWeekInfos: TDisplayWeekInfos;
};

export type TOneBoxV3UpdateRecommendSettingsPayload = {
  resourceConfigs?: Omit<TResourceConfigs, '_id'>[];
  popUp?: TPopUp;
  weekAdjust?: TWeekAdjust;
};

/** Article API（/v1/articles/*）學制字串，與 resourceEduCode 列舉值相同 */
export type TArticleEduCode = '國小' | '國中' | '高中';

export type TArticleAttachmentDto = {
  url: string;
  fileName: string;
  fileSize: number;
  order: number;
};

export type TArticleModelDto = {
  disabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
  _id: string;
  eduCode: TArticleEduCode;
  subject: string;
  academicYear: string;
  grade: string;
  title: string;
  publishAt: string;
  keywords?: string[];
  summary?: string;
  content: string;
  coverImageUrl?: string;
  youtubeUrl?: string;
  attachments: TArticleAttachmentDto[];
  status: 'draft' | 'published';
  createdBy?: string;
};

export type TArticlePaginationReq = {
  page: number | null;
  pageSize: number | null;
  sort: string | null;
  paginateBy?: string | null;
};

export type TArticleSearchDto = {
  eduCodes?: TArticleEduCode[];
  subjects?: string[];
  academicYears?: string[];
  grades?: string[];
};

export type TArticlesGetArticlesPayload = {
  search?: TArticleSearchDto;
  status?: 'draft' | 'published';
  publishDateFrom?: string;
  publishDateTo?: string;
  createdDateFrom?: string;
  createdDateTo?: string;
  pagination: TArticlePaginationReq;
};

export type TArticlesGetArticlesResponse = {
  totalAmount: number;
  totalPages: number;
  currentPage: number;
  data: TArticleModelDto[];
};

export type TArticlesGetArticlePayload = { id: string };

export type TArticlesPublicGetArticlesPayload = {
  search?: TArticleSearchDto;
  pagination: TArticlePaginationReq;
  snapshotTime?: string;
};

export type TArticleCreatePayload = {
  /** 後端 UpdateArticleReqBody／Create 驗證為「字串陣列、至少一筆」 */
  eduCode: TArticleEduCode[];
  subject: string[];
  academicYear: string[];
  grade: string[];
  title: string;
  publishAt: string;
  keywords?: string[];
  summary?: string;
  content: string;
  coverImageUrl?: string;
  youtubeUrl?: string;
  attachments?: TArticleAttachmentDto[];
  status: 'draft' | 'published';
};

export type TArticleUpdatePayload = {
  id: string;
  /** 後端驗證為 isArray + arrayMinSize，須送字串陣列 */
  eduCode?: TArticleEduCode[];
  subject?: string[];
  academicYear?: string[];
  grade?: string[];
  title?: string;
  publishAt?: string;
  keywords?: string[];
  summary?: string;
  content?: string;
  /** 傳 `null` 以清除後端既有封面網址（僅送 `undefined` 時常見合併行為會保留舊值） */
  coverImageUrl?: string | null;
  youtubeUrl?: string | null;
  attachments?: TArticleAttachmentDto[] | null;
  status?: 'draft' | 'published';
};

export type TArticleUploadImageResponse = { url: string };

export type TArticleUploadAttachmentResponse = {
  url: string;
  fileName: string;
  fileSize: number;
};
